Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
Dialog = require 'views/lib/dialog'
IdCache = require 'db/id-cache'
PopOver = require 'views/lib/pop-over'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'views/card/card-limits-error'
LabelLimitsErrorView = require 'views/label/label-limits-error-view'
SelectCardPosition = require 'views/card/select-card-position'
View = require 'view'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = mixin SelectCardPosition, class CardMoveView extends View
  viewTitleKey: 'move card'

  initialize: ({ onCommit }) ->
    @onCommit = onCommit ? (->)
    @listenTo Auth.me().boardList, 'add remove reset', @render

  events:
    'change .js-select-position': 'renderValues'
    'change .js-select-list': 'updatePositionList'
    'change .js-select-board': 'updateBoardData'
    'click .js-submit': 'commitChange'

  render: ->
    data =
      organizations: Auth.me().getOpenBoardsByOrg(true)

    for org in data.organizations
      for board in org.boards
        if board.id == @model.get('idBoard')
          board.selected = true

    partials =
      'move_card_controls': templates.move_card_controls

    @$el.html(
      templates.fill(
        'popover_move_card',
        data,
        {},
        partials
      )
    )

    @updateBoardData()

    @

  commitChange: (e) ->
    $selectBoard = @$('.js-select-board')
    $selectList = @$('.js-select-list')
    $selectPos = @$('.js-select-position')

    idBoardSelected = $selectBoard.find('option:selected').val()
    idListSelected = $selectList.find('option:selected').val()
    posSelected = $selectPos.find('option:selected').val()
    indexSelected = parseInt($selectPos.find('option:selected').prop("index"), 10)

    if idBoardSelected == @model.getBoard().id
      listSelected = @model.getBoard().listList.get(idListSelected)
      options = {
        $elem: @$(e.target),
        destinationList: listSelected,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return

      @model.moveToList(listSelected, indexSelected)
      track("Card", "Move Menu", "Same Board")

    else if idBoardSelected? && idListSelected? && posSelected?
      boardSelected = @modelCache.get('Board', idBoardSelected)
      listSelected = boardSelected?.listList.get(idListSelected)
      options = {
        $elem: @$(e.target),
        hasChecklists: @model.checklistList.length > 0,
        hasAttachments: @model.attachmentList.length > 0,
        destinationBoard: boardSelected,
        destinationList: listSelected,
      }
      if maybeDisplayLimitsErrorOnCardAdd(options)
        return
      hasLabels = @model.getLabels().length > 0
      if hasLabels && boardSelected.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

      track("Card", "Move Menu", "Changed Board")

      @model.getList().cardList.remove(@model)
      # If we're showing a dialog (card detail) then hide it
      Dialog.hide()
      ApiAjax
        url: "/1/cards/#{ @model.id }"
        type: 'put'
        data: { idList: idListSelected, idBoard: idBoardSelected, pos: posSelected }
        success: (data) =>
          @model.board = null
          @model.set('idBoard', data.idBoard)
          @model.set('idList', data.idList)
          @model.set('pos', data.pos)
        error: =>
          @model.getList().cardList.add(@model)
          Alerts.show('could not move card', 'error', 'moveerror', 5000)


    @onCommit()

    PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-move-view.coffee